module.exports = __webpack_public_path__ + "static/media/orange_large_with_text.25eee658.svg";